// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__2fiBp","image":"BackButton_image__hO8j0","text":"BackButton_text__2Ucx9"};